import * as React from "react";
import { SparqlListing } from "app/ui/elements/sparql-listing";
import "./tab.relations.less";

export function TabRelations({ config, currentUri }: { config: any; currentUri: string }) {
    return (
        <SparqlListing
            query={config.query}
            queryParameters={[{ name: "term_iri", type: "uri", value: currentUri }]}
        />
    );
}
